import React, { useState } from 'react';
import {
    Button,
    Heading,
    FormCheckboxGroup,
} from '@snsw/react-component-library';
import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReviewDeclaration, ReviewDeclarations, useApplicationConfig } from '../../store';
import { StandardAppConfig } from '../Configuration';

const UpperWrapper = styled.div`
    margin-top: 0rem;
    line-height: 24px;
`;
const LowerWrapper = styled.div`
    margin-top: 2rem;
    line-height: 24px;
`;

export const Declaration = (
    {
        onChange,
        showError = false,
        initialDeclarations = []
    }: DeclarationProps
) => {
    const appConfig = useApplicationConfig();
    const [declarations, setDeclarations] = useState(initialDeclarations);

    const onChangeEvent = e => {
        const val = e.target.value;

        const checkedOptions = [...declarations];
        checkedOptions.forEach(item => {
            if (item.value === val) {
                item.isChecked = !item.isChecked;
            }
        });
        setDeclarations(checkedOptions);

        onChange(checkedOptions);
    };

    return <>
        <Heading level={ 3 }>Declaration</Heading>
        <UpperWrapper>
            Please read the <Button
                variant='link'
                href={ appConfig.links.termsAndConditionsLink }
            >
                terms and conditions
            </Button>.
            <br /> <br />
            For more information about how we collect, use and disclose your personal information, including who
            we may disclose it to, see our <Button
                variant='link'
                href={ appConfig.links.privacyCollectionNoticeLink }
            >
                Privacy Collection notice
            </Button>.
        </UpperWrapper>
        <FormCheckboxGroup
            id='declaration'
            name='FormCheckbox Name'
            options={ declarations }
            onChange={ onChangeEvent }
            margin={ { top: 'lg' } }
            hasError={ showError }
            errorMessage='Accept all declarations to continue'
        />

        <LowerWrapper>Giving false or misleading information to a public authority is a serious offence
            under the <i>Crimes Act 1900 (NSW)</i>.</LowerWrapper>
    </>;
};

interface DeclarationProps {
    onChange: (newValue: DeclarationCheckbox[]) => void
    showError: boolean,
    initialDeclarations: DeclarationCheckbox[]
}

Declaration.propTypes = {
    onChange: PropTypes.func,
    showError: PropTypes.bool,
    initialDeclarations: PropTypes.array
};

export function standardDeclarations(appConfig: StandardAppConfig): ReviewDeclarations {
    return [
        { isChecked: false, label: 'I have read, understood and accept the terms and conditions.', value: 'termsAndConditions' },
        { isChecked: false, label: 'I am authorised to apply for this payment on behalf of the eligible household.', value: 'authorised' },
        { isChecked: false, label: 'I understand and accept that to prevent any fraud activity, I may be selected for random auditing. I’ll need to keep evidence, including receipts on all items I’ve spent for two years from the grant closing date.', value: 'fraud' },
        { isChecked: false, label: 'I consent to Service NSW and other NSW Government agencies, who may be involved in assessing my application, making enquiries to third parties. I understand that information collected from these third parties is for the purposes of assessing my application and providing the requested services and support.', value: 'consent' },
    ];
}

export type DeclarationCheckbox = ReviewDeclaration

// eslint-disable-next-line import/no-anonymous-default-export
export default Declaration;
